<app-breadcrumb [title]="curentLang === 'en' ? 'Merchant Info' : (curentLang === 'ar' ? ' معلومات التاجر  ' : '  מידע סוחר')" 
[items]="curentLang === 'en' ? ['Dashboard'] : (curentLang === 'ar' ? ['لوحة التحكم'] : ['   לוח הבקרה'])" 
[active_item]="curentLang === 'en' ? 'Merchant Info' : (curentLang === 'ar' ? ' معلومات التاجر  ' : '  מידע סוחר')">
</app-breadcrumb>


<div class="container-fluid ">
    <div class="edit-profile">
      <div class="row">
        <div class="col-xl-4 ">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title mb-0" style="color:  grey;"> 
                {{curentLang === 'en' ? 'Merchant Info' : (curentLang === 'ar' ? ' معلومات التاجر  ' : '  מידע סוחר')}}
            </h5>
              <div class="card-options">
                <a class="card-options-collapse" href="javascript:void(0)" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
              </div>
            </div>
            <div class="card-body">
              <form  [formGroup]=" updateMerchant" novalidate [ngClass]="{ 'was-validated': validate }">
                <div class="row mb-2">
                  <!-- <div class="col-auto"><img class="img-70 rounded-circle" alt="" src="assets/images/user/7.jpg" /></div> -->
                </div>

                <div class="mb-3">
                  <label class="form-label" style="color: grey;"> 
                    {{ curentLang === 'en' ? 'Merchant Name Ar' : (curentLang === 'ar' ? '  اسم التاجر عربي   ' : 'שם סוחר ')}}
                 </label>
                  <input style="color: grey;" onlyAlphabets readonly
                   class="form-control" maxlength="80"  required=""
                   type="text" formControlName="merchant_name_ar" 
                    [(ngModel)]="MerchantNameAr"/>
                    <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter merchant name' : (curentLang === 'ar' ? '   الرجاء ادخال اسم التاجر ' : 'נא להזין את שם הסוחר')}}  </div>

                </div>

                <div class="mb-3">
                    <label class="form-label" style="color: grey;"> 
                      {{ curentLang === 'en' ? 'Merchant Name En' : (curentLang === 'ar' ? '  اسم التاجر انجليزي   ' : 'שם סוחר בערבית ')}}
                   </label>
                    <input style="color: grey;" onlyAlphabets readonly
                    class="form-control"
                     type="text"  required=""
                    maxlength="80" 
                      formControlName="merchant_name_en"
                       [(ngModel)]=" MerchantNameEn"/>
                       <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter merchant name' : (curentLang === 'ar' ? '   الرجاء ادخال اسم التاجر ' : 'נא להזין את שם הסוחר')}}  </div>

                  </div>

                  <div class="mb-3">
                    <label class="form-label" style="color: grey;"> 
                      {{ curentLang === 'en' ? 'Merchant Name He' : (curentLang === 'ar' ? '  اسم التاجر عبري   ' : 'שם סוחר אנגלית')}}
                   </label>
                    <input style="color: grey;" class="form-control" onlyAlphabets readonly
                     type="text" 
                     formControlName="merchant_name_he"  required=""
                     maxlength="80" 
                     [(ngModel)]=" MerchantNameHe"/>
                     <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter merchant name' : (curentLang === 'ar' ? '   الرجاء ادخال اسم التاجر ' : 'נא להזין את שם הסוחר')}}  </div>

                  </div>

                  <div class="mb-3">
                    <label class="form-label" style="color: grey;"> 
                      {{ curentLang === 'en' ? 'Merchant Address En' : (curentLang === 'ar' ? '  عنوان التاجر انجليزي   ' : ' כתובת עוסק   ')}}
                   </label>
                    <input style="color: grey;"  readonly
                    class="form-control" type="text" 
                     formControlName="merchant_address" onlyAlphabets
                     maxlength="400" required=""
                       [(ngModel)]=" MerchantAddress"/>
                       <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter merchant address' : (curentLang === 'ar' ? '   الرجاء ادخال عنوان التاجر ' : 'נא להזין את כתובת הסוחר')}}  </div>

                  </div>

                  <div class="mb-3">
                    <label class="form-label" style="color: grey;"> 
                      {{ curentLang === 'en' ? 'Id Number' : (curentLang === 'ar' ? ' رقم الهوية  ' : ' מספר ישות (ת.ז / ח.פ.)  ')}}
                   </label>
                    <input style="color: grey;" onlyAlphabets
                    class="form-control" type="text"  readonly
                     formControlName="id_number"
                     maxlength="400" required=""
                       [(ngModel)]=" IdNumber"/>
                       <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter id number  ' : (curentLang === 'ar' ? '   الرجاء ادخال رقم الهوية ' : '  נא להזין את מספר תעודת הזהות שלך')}}  </div>

                  </div>

                  <!-- <div class="form-footer" style="margin-top: 74px;">
                    <button class="btn d-block w-100 me-1" style=" background-color: #213FA6;color: #fff;" (click)="updateMerchantById()"> 
                      {{ curentLang === 'en' ? 'Update' : (curentLang === 'ar' ? 'تعديل ' : 'עדכן')}}
                      <i class="fa fa-check-circle mx-1"></i>
                    </button>
                    </div> -->
              </form>
            </div>
          </div>
        </div>
       
        <div class="col-md-8 ">
          <div class="card " *ngIf="showSubscriptionSection">
              <div class="card-header mx-4">
                  <h5 style="color: grey;">{{ curentLang === 'en' ? 'Invoice subscription' : (curentLang === 'ar' ? 'اشتراك الفواتير' : 'מנוי חשבוניות') }}</h5>
                </div>
              <div class="card-body">
                  <div *ngIf="v2SubscriptionLoading" class="text-center py-4 text-muted">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    {{ curentLang === 'en' ? 'Loading…' : (curentLang === 'ar' ? 'جاري التحميل…' : 'טוען…') }}
                  </div>
                  <div *ngIf="!v2SubscriptionLoading && v2SubscriptionError" class="alert alert-warning mb-0">
                    {{ curentLang === 'en' ? 'Could not load subscription (admin API).' : (curentLang === 'ar' ? 'تعذر تحميل بيانات الاشتراك.' : 'לא ניתן לטעון את פרטי המנוי.') }}
                  </div>
                  <ng-container *ngIf="!v2SubscriptionLoading && !v2SubscriptionError">
                    <div *ngIf="!v2SubscriptionStatus?.subscription" class="text-muted">
                      {{ curentLang === 'en' ? 'No active subscription.' : (curentLang === 'ar' ? 'لا يوجد اشتراك نشط.' : 'אין מנוי פעיל.') }}
                    </div>
                    <div class="row" *ngIf="v2SubscriptionStatus?.subscription">
                      <div class="col-xxl-4 col-sm-6 box-col-6 mb-3">
                        <div class="card small-widget">
                          <div class="card-body {{ newOrders.colorClass }}">
                            <span class="f-light">{{ curentLang === 'en' ? 'Plan' : (curentLang === 'ar' ? 'الخطة' : 'תוכנית') }}</span>
                            <div class="d-flex align-items-end gap-1">
                              <h4 style="color: grey;">{{ getPlanDisplayName(v2SubscriptionStatus.subscription.plan) }}</h4>
                            </div>
                            <div class="bg-gradient">
                              <svg class="stroke-icon svg-fill"><use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use></svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xxl-4 col-sm-6 box-col-6 mb-3">
                        <div class="card small-widget">
                          <div class="card-body {{ newOrders.colorClass }}">
                            <span class="f-light">{{ curentLang === 'en' ? 'Status' : (curentLang === 'ar' ? 'الحالة' : 'סטטוס') }}</span>
                            <div class="d-flex align-items-end gap-1">
                              <h4 style="color: grey;">{{ v2SubscriptionStatus.subscription.status }}</h4>
                            </div>
                            <div class="bg-gradient">
                              <svg class="stroke-icon svg-fill"><use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon2 }}"></use></svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xxl-4 col-sm-6 box-col-6 mb-3">
                        <div class="card small-widget">
                          <div class="card-body {{ newOrders.colorClass }}">
                            <span class="f-light">{{ curentLang === 'en' ? 'Days remaining' : (curentLang === 'ar' ? 'أيام متبقية' : 'ימים נותרים') }}</span>
                            <div class="d-flex align-items-end gap-1">
                              <h4 style="color: grey;">{{ v2SubscriptionStatus.days_remaining }}</h4>
                            </div>
                            <div class="bg-gradient">
                              <svg class="stroke-icon svg-fill"><use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon3 }}"></use></svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xxl-4 col-sm-6 box-col-6 mb-3" *ngIf="v2SubscriptionStatus.subscription.start_date">
                        <div class="card small-widget">
                          <div class="card-body {{ newOrders.colorClass }}">
                            <span class="f-light">{{ curentLang === 'en' ? 'Start' : (curentLang === 'ar' ? 'البداية' : 'התחלה') }}</span>
                            <div class="d-flex align-items-end gap-1">
                              <h4 style="color: grey;">{{ v2SubscriptionStatus.subscription.start_date | date : 'dd/MM/yyyy' }}</h4>
                            </div>
                            <div class="bg-gradient">
                              <svg class="stroke-icon svg-fill"><use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use></svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xxl-4 col-sm-6 box-col-6 mb-3" *ngIf="v2SubscriptionStatus.subscription.end_date">
                        <div class="card small-widget">
                          <div class="card-body {{ newOrders.colorClass }}">
                            <span class="f-light">{{ curentLang === 'en' ? 'End' : (curentLang === 'ar' ? 'النهاية' : 'סיום') }}</span>
                            <div class="d-flex align-items-end gap-1">
                              <h4 style="color: grey;">{{ v2SubscriptionStatus.subscription.end_date | date : 'dd/MM/yyyy' }}</h4>
                            </div>
                            <div class="bg-gradient">
                              <svg class="stroke-icon svg-fill"><use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon4 }}"></use></svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ng-container *ngIf="getSubscriptionUsage() as usage">
                        <div class="col-xxl-4 col-sm-6 box-col-6 mb-3">
                          <div class="card small-widget">
                            <div class="card-body {{ newOrders.colorClass }}">
                              <span class="f-light">{{ curentLang === 'en' ? 'Documents' : (curentLang === 'ar' ? 'المستندات' : 'מסמכים') }}</span>
                              <div class="d-flex align-items-end gap-1">
                                <h4 style="color: grey;">{{ usage.documents_used }} / {{ usage.documents_limit }}</h4>
                              </div>
                              <div class="bg-gradient">
                                <svg class="stroke-icon svg-fill"><use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use></svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xxl-4 col-sm-6 box-col-6 mb-3">
                          <div class="card small-widget">
                            <div class="card-body {{ newOrders.colorClass }}">
                              <span class="f-light">{{ curentLang === 'en' ? 'Companies' : (curentLang === 'ar' ? 'المصالح التجارية' : 'חברות') }}</span>
                              <div class="d-flex align-items-end gap-1">
                                <h4 style="color: grey;">{{ usage.companies_used }} / {{ usage.companies_limit }}</h4>
                              </div>
                              <div class="bg-gradient">
                                <svg class="stroke-icon svg-fill"><use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon2 }}"></use></svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <div class="col-xxl-4 col-sm-6 box-col-6 mb-3">
                        <div class="card small-widget">
                          <div class="card-body {{ newOrders.colorClass }}">
                            <span class="f-light">{{ curentLang === 'en' ? 'Documents left' : (curentLang === 'ar' ? 'مستندات متبقية' : 'מסמכים נותרים') }}</span>
                            <div class="d-flex align-items-end gap-1">
                              <h4 style="color: grey;">{{ v2SubscriptionStatus.documents_remaining }}</h4>
                            </div>
                            <div class="bg-gradient">
                              <svg class="stroke-icon svg-fill"><use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon3 }}"></use></svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xxl-4 col-sm-6 box-col-6 mb-3">
                        <div class="card small-widget">
                          <div class="card-body {{ newOrders.colorClass }}">
                            <span class="f-light">{{ curentLang === 'en' ? 'Companies left' : (curentLang === 'ar' ? 'مصالح تجارية متبقية' : 'חברות נותרות') }}</span>
                            <div class="d-flex align-items-end gap-1">
                              <h4 style="color: grey;">{{ v2SubscriptionStatus.companies_remaining }}</h4>
                            </div>
                            <div class="bg-gradient">
                              <svg class="stroke-icon svg-fill"><use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon4 }}"></use></svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3" *ngIf="v2SubscriptionStatus?.latest_pending_admin_payment_link">
                      <label class="form-label small text-muted">{{ curentLang === 'en' ? 'Pending payment link' : (curentLang === 'ar' ? 'رابط دفع معلّق' : 'קישור תשלום ממתין') }}</label>
                      <div class="input-group input-group-sm">
                        <input class="form-control" [value]="v2SubscriptionStatus.latest_pending_admin_payment_link" readonly />
                        <button type="button" class="btn btn-outline-primary" (click)="copyPendingPaymentLink(v2SubscriptionStatus.latest_pending_admin_payment_link)">
                          <i class="fa fa-copy"></i>
                        </button>
                        <a class="btn btn-outline-secondary" [href]="v2SubscriptionStatus.latest_pending_admin_payment_link" target="_blank" rel="noopener noreferrer">
                          <i class="fa fa-external-link"></i>
                        </a>
                      </div>
                    </div>
                  </ng-container>
              </div>
          </div>
        <!--back-->
        <div class=" d-flex justify-content-end"> 
          <a routerLink="/dashboard/merchant-info">
            <button class="btn btn-danger m-2 ml-auto" >
              {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? '  رجوع ' : '  חזרה  ') }}
              <i class="fa fa-rotate-left mx-1"></i>
            </button>
          </a>
        </div>
        </div>

    </div>
      
    </div>
    
  </div>




